import React, { useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { ExternalLink } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useBooking } from "../context/BookingContext";
import { SETMORE_URL } from "../lib/site";

const BookingModal = () => {
  const { t } = useLang();
  const { open, setOpen } = useBooking();

  // Escape-to-close even when iframe has focus
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, setOpen]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="booking-modal"
        className="max-w-5xl w-[95vw] h-[88vh] p-0 bg-[#0a0a0a] border border-gold/20 rounded-sm overflow-hidden text-white"
      >
        <DialogHeader className="px-6 py-4 border-b border-white/10 flex flex-row items-center justify-between space-y-0">
          <div>
            <DialogTitle className="font-display uppercase text-xl tracking-tight text-white">
              {t.booking.title}
            </DialogTitle>
            <DialogDescription className="text-white/50 text-sm">
              {t.booking.subtitle}
            </DialogDescription>
          </div>
          <a
            href={SETMORE_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="open-setmore-tab"
            className="hidden md:inline-flex items-center gap-1.5 label-eyebrow text-gold hover:text-white transition-colors"
          >
            Open in tab <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </DialogHeader>
        <div className="relative w-full h-[calc(88vh-72px)] bg-black">
          <iframe
            title="Setmore booking"
            src={open ? SETMORE_URL : "about:blank"}
            key={open ? "setmore-open" : "setmore-closed"}
            className="absolute inset-0 w-full h-full"
            style={{ border: 0 }}
            allow="payment; clipboard-read; clipboard-write; geolocation"
            referrerPolicy="no-referrer-when-downgrade"
            data-testid="setmore-iframe"
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BookingModal;
